import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useLoansStore} from "../../store/loans.store";

export const useLoanVendorProducts = (productId) => {
    const setLoanVendorProducts = useLoansStore((state) => state.setLoanVendorProducts);

    return useMutation(PartnerApi.loanVendorProducts, {
        onSuccess: (data) => {
            setLoanVendorProducts(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};